import React from 'react'
import { IconRegularCheckmark, IconRegularClose } from '@notino/react-styleguide'
import VisuallyHidden from '../../../../atoms/VisuallyHidden/VisuallyHidden'
import { SalonDetail } from '../../../../types/types'
import useMessages from '../../../../hooks/useMessages'
import * as SC from './PaymentDetailsStyles'

const Icon = ({
	paymentAvailable,
	ariaLabelAvailable,
	ariaLabelUnavailable
}: {
	paymentAvailable: boolean | undefined
	ariaLabelAvailable: string
	ariaLabelUnavailable: string
}) => {
	return paymentAvailable ? (
		<>
			<IconRegularCheckmark color={'icon.primary'} aria-hidden='true' />
			<VisuallyHidden>{ariaLabelAvailable}</VisuallyHidden>
		</>
	) : (
		<>
			<IconRegularClose color={'icon.tertiary'} width='20' height='20' style={{ marginRight: 2 }} aria-hidden='true' />
			<VisuallyHidden>{ariaLabelUnavailable}</VisuallyHidden>
		</>
	)
}

type Props = {
	salonData: SalonDetail
}

const PaymentDetails = (props: Props) => {
	const { messages } = useMessages()
	const { salonData } = props

	return (
		<SC.PaymentMethodsDescriptionList>
			<SC.PaymentMethodDescriptionItem>
				<SC.PaymentMethodDescriptionTerm $isAvailable={!!salonData.payByCash}>{messages['Cash payment']}</SC.PaymentMethodDescriptionTerm>
				<SC.PaymentMethodDescriptionDescription>
					<Icon
						paymentAvailable={salonData.payByCash}
						ariaLabelAvailable={messages['Cash payment available']}
						ariaLabelUnavailable={messages['Cash payment unavailable']}
					/>
				</SC.PaymentMethodDescriptionDescription>
			</SC.PaymentMethodDescriptionItem>
			<SC.PaymentMethodDescriptionItem>
				<SC.PaymentMethodDescriptionTerm $isAvailable={!!salonData.payByCard}>{messages['Card payment']}</SC.PaymentMethodDescriptionTerm>
				<SC.PaymentMethodDescriptionDescription>
					<Icon
						paymentAvailable={salonData.payByCard}
						ariaLabelAvailable={messages['Card payment available']}
						ariaLabelUnavailable={messages['Card payment unavailable']}
					/>
				</SC.PaymentMethodDescriptionDescription>
			</SC.PaymentMethodDescriptionItem>
			{salonData?.otherPaymentMethods && (
				<>
					<SC.PaymentMethodDescriptionTerm $isAvailable={true}>{messages['Other payment methods']}</SC.PaymentMethodDescriptionTerm>
					<SC.PaymentMethodDescriptionDescription>
						<SC.PaymentsInfoContainer>{salonData?.otherPaymentMethods}</SC.PaymentsInfoContainer>
					</SC.PaymentMethodDescriptionDescription>
				</>
			)}
		</SC.PaymentMethodsDescriptionList>
	)
}

export default PaymentDetails
